<template>
  <AppShell v-if="!isPublicRoute" />
  <RouterView v-else />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute, RouterView } from "vue-router";
import AppShell from "@/components/AppShell.vue";

const route = useRoute();
const isPublicRoute = computed(() => route.meta.public === true);
</script>
